import { Action } from "@ngrx/store";
import { IPartnerBranding } from "../../domain/partner-branding.model";

/**
 * SAN-384/386 — Hub/Spoke partner branding.
 *
 * A separate slice on purpose: the tenant-wide `global` slice keeps holding the
 * hub's own brand details exactly as it does today, and this slice layers a
 * spoke partner's branding on top of it. Nothing here ever overwrites `global`.
 */
export enum PartnerBrandingActionTypes {
  SetPartnerAbbreviation = "[PartnerBranding] SetPartnerAbbreviation",

  GetPartnerBranding = "[PartnerBranding] GetPartnerBranding",
  GetPartnerBrandingSuccess = "[PartnerBranding] GetPartnerBrandingSuccess",
  GetPartnerBrandingFault = "[PartnerBranding] GetPartnerBrandingFault",
}

/**
 * Carries the optional `partnerAbbreviation` off the cockpit's
 * `resolve-domain/:hostname` response. `null` for every hub/root hostname.
 */
export class SetPartnerAbbreviation implements Action {
  readonly type = PartnerBrandingActionTypes.SetPartnerAbbreviation;

  constructor(public payload: string | null) { }
}

export class GetPartnerBranding implements Action {
  readonly type = PartnerBrandingActionTypes.GetPartnerBranding;

  constructor(public payload: string) { }
}

export class GetPartnerBrandingSuccess implements Action {
  readonly type = PartnerBrandingActionTypes.GetPartnerBrandingSuccess;

  constructor(public payload: IPartnerBranding) { }
}

export class GetPartnerBrandingFault implements Action {
  readonly type = PartnerBrandingActionTypes.GetPartnerBrandingFault;

  constructor(public payload: string) { }
}

export type PartnerBrandingActions =
  | SetPartnerAbbreviation
  | GetPartnerBranding
  | GetPartnerBrandingSuccess
  | GetPartnerBrandingFault;
